'use client';
import { AlertCircle } from "lucide-react";
export function Err({ children }: { children: React.ReactNode }) {
  return (
    <p className="text-xs text-red-500 mt-1.5 flex items-center gap-1">
      <AlertCircle className="h-3 w-3 flex-shrink-0" />{children}
    </p>
  );
}
